import genererCritereRecherche
  from '@/services/logistique/ordreTravail/impression/genererCritereRecherche';
import * as types from '@/store/modules/logistique/ordreTravailImpression-mutation-type';
import * as allTypes from '@/store/mutation-type';
import getAll from '@/api/logistique/ordreTravailImpression';
import getPiecesJointeLogoByIds from '@/services/piecesJointes/getPiecesJointeLogoByIds';

function initialState() {
  return {
    items: [],
    totalCount: 0,
    criteresRecherche: genererCritereRecherche(),
    lastPayload: {},
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_ITEMS](state, items) {
    state.items = items;
  },
  [types.SET_LAST_PAYLOAD](state, payload) {
    state.lastPayload = payload;
  },
  [types.SET_TOTAL_COUNT](state, count) {
    state.totalCount = count;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [types.SET_OT_SELECT](state, params) {
    state.items = state.items.map(item => {
      if (params.otId) {
        item.otImpressions = item.otImpressions.map(otEImpression => {
          if (otEImpression.id === params.otId) {
            otEImpression.selected = !otEImpression.selected;
          }
          return otEImpression;
        });
        if (item.otImpressions.every(ot => ot.selected)) {
          item.selected = true;
        } else {
          item.selected = false;
        }
      }
      if (!params.otId) {
        item.otImpressions = item.otImpressions.map(otEImpression => {
          otEImpression.selected = item.selected;
          return otEImpression;
        });
      }
      return item;
    });
  },
  [types.SET_CRITERE](state, critere) {
    state.criteresRecherche = critere;
  },
};

const actions = {
  async loadOtImpressions({ commit }, data) {
    commit(types.SET_LAST_PAYLOAD, data);
    const response = await getAll(data);
    if (!data.withoutImage) await getPiecesJointeLogoByIds(response.data.result.items, 'campagneId');
    response.data.result.items.forEach((ot) => {
      ot.qteAImprimer = ot.otImpressions.map((t) => t.quantite)
        .reduce((a, b) => a + b, 0);
      ot.selected = false;
    });
    commit(types.SET_TOTAL_COUNT, response.data.result.totalCount);
    commit(types.SET_ITEMS, response.data.result.items);
    return {};
  },
};

const getters = {
  items: state => {
    return state.items;
  },
  totalCount: state => {
    return state.totalCount;
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
